import React from "react";
import IconMapLocator from "../assets/svg/icon-map-locator.svg";

import KigaliSpaceImage from "../assets/images/kigali_space.jpeg";
import NairobiImage from "../assets/images/sc-nairobi.jpg";
import LekiCenterImage from "../assets/images/stemcafe-center-3.jpg";
import YabaCenterImage from "../assets/images/stemcafe-center-4.jpg";
import PortHarcourtImage from "../assets/images/port-harcout.jpg";

const Centers: React.FC = () => {
  return (
    <div id="centers">
      <div className="container">
        <h3>Centers</h3>
        <div className="row">
          <div className="col-md-4">
            <div className="center-wrap">
              <div
                className="center-picture"
                style={{ backgroundImage: `url(${KigaliSpaceImage})` }}
              ></div>
              <div className="center-info">
                <ul className="center-location">
                  <li>
                    <h4>Kigali</h4>
                  </li>
                  <li>
                    <a
                      href="https://goo.gl/maps/p1uAUuHzEaXHFpPJ8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get directions
                    </a>
                  </li>
                </ul>
                <ul className="address-time">
                  <li>
                    <img src={IconMapLocator} alt="" />
                    First Floor, Golden Plaza, KG 546, St. 1 Kacyiru, Kigali
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="center-wrap">
              <div
                className="center-picture"
                style={{ backgroundImage: `url(${NairobiImage})` }}
              ></div>
              <div className="center-info">
                <ul className="center-location">
                  <li>
                    <h4>Nairobi</h4>
                  </li>
                  <li>
                    <a
                      href="https://maps.app.goo.gl/HFiiu5w8jGN4Uwvq5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get directions
                    </a>
                  </li>
                </ul>
                <ul className="address-time">
                  <li>
                    <img src={IconMapLocator} alt="" />
                    154 James Gichuru Road, Jahazi, Nairobi
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="center-wrap">
              <div
                className="center-picture"
                style={{ backgroundImage: `url(${LekiCenterImage})` }}
              ></div>
              <div className="center-info">
                <ul className="center-location">
                  <li>
                    <h4>Lekki</h4>
                  </li>
                  <li>
                    <a
                      href="https://goo.gl/maps/8aJ21RUviGcjwXvS6"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get directions
                    </a>
                  </li>
                </ul>
                {/* <ul className="address-time"> */}
                {/*   <li> */}
                {/*     <img src={IconMapLocator} alt="" /> */}
                {/*     1st Floor, 10Bou Plaza, Beside Global International School. */}
                {/*     Admiralty way, Lekki, Lagos, Nigeria. */}
                {/*   </li> */}
                {/* </ul> */}
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="center-wrap">
              <div
                className="center-picture"
                style={{ backgroundImage: `url(${YabaCenterImage})` }}
              ></div>
              <div className="center-info">
                <ul className="center-location">
                  <li>
                    <h4>Yaba</h4>
                  </li>
                  <li>
                    <a
                      href="https://goo.gl/maps/WDDKGi63LheHfbMSA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get directions
                    </a>
                  </li>
                </ul>
                <ul className="address-time">
                  <li>
                    <img src={IconMapLocator} alt="" />
                    3rd Floor, 8 Montgomery Road, Sabo Yaba
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="center-wrap">
              <div
                className="center-picture"
                style={{ backgroundImage: `url(${PortHarcourtImage})` }}
              ></div>
              <div className="center-info">
                <ul className="center-location">
                  <li>
                    <h4>Port Harcourt</h4>
                  </li>
                  <li>
                    <a
                      href="https://maps.app.goo.gl/ecesnYnsod49dkim8"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Get directions
                    </a>
                  </li>
                </ul>
                <ul className="address-time">
                  <li>
                    <img src={IconMapLocator} alt="" />
                    26 Isiokpo Street, D-Line, Port Harcourt
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Centers;
